(function (angular) {
	'use strict';

	angular.module('cancelRedemptionRequestModalModule', [
		'apiModule',
		'coreModule',
		'formValidationModule'
	]);
})(window.angular);
